export default __webpack_public_path__ + "static/media/servico1.1be28aa7.jpg";